<div [class.p-4]="!inCheckout">
  <div
    class="alert alert-warning d-md-flex justify-content-between"
    role="alert"
    *ngIf="cartItem.status != 'Available' && !onMachineDetails"
  >
    <div>
      {{ cartItem.inventoryItem.make }} {{ cartItem.inventoryItem.model }} is
      not available.
    </div>
    <u class="text-underline cursor-pointer" (click)="removeFromCart()"
      >Remove</u
    >
  </div>
  <div class="d-flex fs-18">
    <div>Summary</div>
    <div class="ml-auto">{{ rateLabel }}</div>
  </div>
  <div class="bb-light mb-3 mt-1"></div>
  <!-- machine -->
  <div class="d-flex align-items-center">
    <app-thumbnail-with-x
      *ngIf="!onMachineDetails"
      [height]="inCheckout ? '125px' : '125px'"
      [width]="inCheckout ? '125px' : '125px'"
      borderRadius="5px"
      [imgSrc]="cartItem.imageThumbnail"
      [hideX]="!inCheckout || isQuote"
      (xClicked)="confirmRemoveItem()"
    ></app-thumbnail-with-x>
    <div [class.ml-2]="!onMachineDetails" style="line-height: 26px">
      <ng-container *ngIf="!onMachineDetails">
        <div class="teko fs-26" style="font-weight: 500">
          {{ cartItem.inventoryItem.make }} {{ cartItem.inventoryItem.model }}
        </div>
        <div class="font-weight-light">
          {{ cartItem.inventoryItem.year }}
          {{ cartItem.inventoryItem.primaryType }}
        </div>
      </ng-container>

      <ng-container *ngIf="inCheckout">
        <ng-container *ngIf="isEstimate">
          <div class="bold">Rental Rate</div>
        </ng-container>
        <ng-container *ngIf="!isEstimate">
          <div class="font-weight-light">
            {{ cartItem.beginDate | date : "mediumDate" }}
          </div>
          <div class="font-weight-light">{{ cartItem.formattedDuration }}</div>
        </ng-container>
      </ng-container>
    </div>
    <div class="ml-auto">
      <div class="fs-20 bold">
        {{ (rentBeforeDiscount > 0 ? rentBeforeDiscount : rateSummary?.Rent) | currency : "USD" : "symbol" : "1.0-0" }}
      </div>
      <button
        *ngIf="inCheckout && !isEstimate && !onMachineDetails && !isQuote"
        class="float-right cursor-pointer ml-auto btn btn-outline-success"
        (click)="editClick()"
      >
        Edit
      </button>
    </div>
  </div>
  <div class="bb-light my-3"></div>
  <!-- attachments -->
  <div *ngIf="cartItem.attachments.length">
    <p>Attachments</p>
    <ng-container *ngFor="let attachment of cartItem.attachments">
      <div class="d-flex mb-1">
        <div>
          <div class="font-weight-light">{{ attachment.title }}</div>
          <div class="font-weight-light mr-5 fs-14">
            {{ attachment.description }}
          </div>
        </div>
        <div class="ml-auto">
          {{
            attachment[attachmentRateProperty]
              | currency : "USD" : "symbol" : "1.0-0"
          }}
        </div>
      </div>
    </ng-container>
    <div class="bb-light my-3"></div>
  </div>

  <!-- services -->
  <div class="d-flex">
    <div>
      <u class="cursor-pointer" (click)="servicesTooltip.open()"
        >Rubbl Managed Services</u
      >
    </div>
    <app-questionmark-tooltip
      class="ml-2"
      [displayLearnMore]="false"
      text="A fee of 15% of your rental rate. Includes damage and liability coverage, transportation logistics, and repair coordination. Minimum $149."
      #servicesTooltip
    >
    </app-questionmark-tooltip>
    <div class="ml-auto">
      {{ rateSummary?.PremiumServices | currency : "USD" : "symbol" : "1.0-0" }}
    </div>
  </div>
  <!-- Taxes -->
  <ng-container>
    <div class="bb-light my-3"></div>
    <div class="d-flex">
      <div>
        <u class="cursor-pointer" (click)="salestaxTooltip.open()">Taxes</u>
      </div>
      <app-questionmark-tooltip
        class="ml-2"
        mobilePlacement="right"
        [displayLearnMore]="false"
        text="Sales tax calculations take into account both equipment origin and destination. Sales tax is calculated during checkout."
        #salestaxTooltip
      >
      </app-questionmark-tooltip>
      <div class="ml-auto" *ngIf="rateSummary?.Tax != null">
        {{ rateSummary?.Tax | currency : "USD" : "symbol" : "1.0-0" }}
      </div>
      <div class="ml-auto" *ngIf="rateSummary?.Tax == null">-</div>
    </div>
  </ng-container>

  <!-- transportation - only show when we have an estimate -->
  <ng-container
    *ngIf="
      cartItem.transportationEstimateSummary?.estimatedCost &&
      !toExpensiveToEstimate
    "
  >
    <div class="bb-light my-3"></div>
    <div class="d-flex align-items-center">
      <div>
        <u class="cursor-pointer" (click)="transportTooltip.open()"
          >Transportation Round Trip</u
        >
      </div>
      <app-questionmark-tooltip
        class="ml-2"
        [displayLearnMore]="false"
        [text]="transportationTooltipText"
        #transportTooltip
      >
      </app-questionmark-tooltip>
      <div class="ml-auto d-flex align-items-center">
        <!-- Show strikethrough cost and $0 when self-transport selected -->
        <ng-container *ngIf="getEffectiveDeliveryOption() === DeliveryOptions.PickUp">
          <span class="text-muted text-strikethrough mr-2">
            {{ cartItem.transportationEstimateSummary?.estimatedCost | currency : "USD" : "symbol" : "1.0-0" }}
          </span>
          <span class="text-success font-weight-bold">$0</span>
        </ng-container>
        <!-- Normal cost display for delivery -->
        <ng-container *ngIf="getEffectiveDeliveryOption() !== DeliveryOptions.PickUp">
          {{ cartItem.transportationEstimateSummary?.estimatedCost | currency : "USD" : "symbol" : "1.0-0" }}
        </ng-container>
      </div>
    </div>
    <div class="d-flex align-items-center mt-1">
      <span class="text-muted fs-12">Powered by</span>
      <img
        class="ml-1"
        style="height: 28px"
        src="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl-ai-2.png"
        alt="Rubbl AI"
      />
    </div>
  </ng-container>

  <!-- transportation - on machine details page with no estimate yet -->
  <ng-container *ngIf="onMachineDetails && (toExpensiveToEstimate || !cartItem.transportationEstimateSummary?.estimatedCost)">
    <div class="bb-light my-3"></div>
    <div class="d-flex align-items-center">
      <div>
        <u class="cursor-pointer" (click)="machineDetailsTransportTooltip.open()"
          >Transportation Round Trip</u
        >
      </div>
      <app-questionmark-tooltip
        class="ml-2"
        [displayLearnMore]="false"
        text="Enter delivery ZIP code during the book now process to see cost."
        #machineDetailsTransportTooltip
      >
      </app-questionmark-tooltip>
      <div class="ml-auto">-</div>
    </div>
    <div class="d-flex align-items-center mt-1">
      <span class="text-muted fs-12">Powered by</span>
      <img
        class="ml-1"
        style="height: 28px"
        src="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl-ai-2.png"
        alt="Rubbl AI"
      />
    </div>
  </ng-container>

  <!-- transportation - too expensive to estimate OR no estimate available (non-machine-details pages) -->
  <ng-container *ngIf="!onMachineDetails && (toExpensiveToEstimate || !cartItem.transportationEstimateSummary?.estimatedCost)">
    <div class="bb-light my-3"></div>
    <div class="d-flex align-items-center">
      <div>Transportation Round Trip</div>
      <!-- Show $0 if user selected PickUp -->
      <div class="ml-auto" *ngIf="getEffectiveDeliveryOption() === DeliveryOptions.PickUp">
        <span class="text-success font-weight-bold">$0</span>
      </div>
      <!-- Show warning icon if Delivery selected but can't estimate -->
      <div class="ml-auto" *ngIf="getEffectiveDeliveryOption() !== DeliveryOptions.PickUp">
        <i class="icon-notification1 fs-24 text-warning"></i>
      </div>
    </div>
    <!-- Only show sorry message if Delivery is selected -->
    <p class="mt-2 mb-0 font-weight-light" *ngIf="getEffectiveDeliveryOption() !== DeliveryOptions.PickUp">
      Sorry, in order to provide a transportation estimate we need to take a closer look. Continue to place the order and we will provide the lowest quote within 1 business day.
    </p>
  </ng-container>

  <!-- Coupon Discount -->
  <ng-container *ngIf="discountAmount > 0">
    <div class="bb-light my-3"></div>
    <div class="d-flex text-success">
      <div>Coupon Discount ({{ discountPercent }}%)</div>
      <div class="ml-auto">-{{ discountAmount | currency : "USD" : "symbol" : "1.0-0" }}</div>
    </div>
  </ng-container>

  <div class="bb-light my-3"></div>
  <div class="d-flex fs-20">
    <div>{{ rateLabel }} Total</div>
    <div class="ml-auto">
      {{ total | currency : "USD" : "symbol" : "1.0-0" }}
    </div>
  </div>
  <div class="bb-light my-3"></div>
  <div class="d-flex fs-20 mt-2" *ngIf="rentalTotal > 0">
    <div>Rental Total</div>
    <div class="ml-auto">
      {{ grandTotal | currency : "USD" : "symbol" : "1.0-0" }}
    </div>
  </div>
</div>
